import { API_PATH } from "../../utils/Constants";
import { currentServerRoutePrefix, getParamValue } from "../../utils/UtilMethods";
import EndpointsBase from "../EndpointsBase";
import ServerRequestWrapper from "../ServerRequestWrapper";
import constants from "../aframeboxlookup/Constants";
const { LookupValueOrigin, LookupValueType } = constants;
console.log(API_PATH + currentServerRoutePrefix);
class ConveyorBoxEndpoints extends EndpointsBase {
  _server = new ServerRequestWrapper(API_PATH + currentServerRoutePrefix);

  getConveyorBox(valueOrigin, lookupValue, workstationId) {
    let data = void 0;

    const method = ((valueOrigin, lookupValue, workstationId) => {
      switch (valueOrigin) {
        case LookupValueOrigin.ScannedBarcode:
          data = {
            barcode: lookupValue,
            workstationId,
          };
          return `/box/barcode/${lookupValue}`;
        case LookupValueOrigin.SortBoxNumber:
          data = {
            id: lookupValue,
            type: LookupValueType.SortBox,
            workstationId,
          };
          return `/box/id`;
        case LookupValueOrigin.InvoiceNumber:
          data = {
            id: lookupValue,
            type: LookupValueType.Invoice,
            workstationId,
          };
          return `/box/id`;
        case LookupValueOrigin.IpackBoxNumber:
          data = {
            id: lookupValue,
            type: LookupValueType.IpackBoxID,
            workstationId,
          };
          return `/box/id`;
        default:
          return void 0;
      }
    })(valueOrigin, lookupValue, workstationId);

    return this._sendRequest({
      method: method,
      headers: this._getAuthHeader(),
      run: this._server.get,
      data: data,
    });
  }
  updatePickedQuantity(barcode, payload) {
    return this._sendRequest({
      method: `/box/${barcode}/picked-quantity`,
      headers: this._getAuthHeader(),
      run: this._server.postData,
      data: payload,
    });
  }
  updateBoxBarcode(currentBarcode, newBarcode, selectedBoxSize) {
    let data = {
      currentBarcode,
      newBarcode,
      selectedBoxSize,
    };
    return this._sendRequest({
      method: `/box/${currentBarcode}/update-barcode`,
      headers: this._getAuthHeader(),
      run: this._server.putData,
      data,
    });
  }
  getStock(currentBarcode, data) {
    return this._sendRequest({
      method: `/box/${currentBarcode}/getStock`,
      headers: this._getAuthHeader(),
      run: this._server.postData,
      data,
    });
  }
  triggerPostPick(currentBarcode, data) {
    return this._sendRequest({
      method: `/box/${currentBarcode}/post-pick`,
      headers: this._getAuthHeader(),
      run: this._server.postData,
      data,
    });
  }
  triggerBatchPick(currentBarcode, data) {
    return this._sendRequest({
      method: `/box/${currentBarcode}/batch-pick`,
      headers: this._getAuthHeader(),
      run: this._server.postData,
      data,
    });
  }
  confirmItemRemoval(currentBarcode, data) {
    return this._sendRequest({
      method: `/box/${currentBarcode}/confirm-item-removal`,
      headers: this._getAuthHeader(),
      run: this._server.postData,
      data,
    });
  }
  finishSkuPutaway(currentBarcode, data) {
    return this._sendRequest({
      method: `/box/${currentBarcode}/create-partial-delivery`,
      headers: this._getAuthHeader(),
      run: this._server.postData,
      data,
    });
  }
  setBoxAsControlled(currentBarcode, adjustedPicks) {
    return this._sendRequest({
      method: `/box/${currentBarcode}/controlled`,
      headers: this._getAuthHeader(),
      run: this._server.postData,
      data: adjustedPicks,
    });
  }

  loadContentImage(boxBarcode) {
    return this._sendRequest({
      method: "review/imageraw",
      headers: {
        WorkstationID: getParamValue("ws"),
      },
      data: { boxBarcode },
      run: this.server.getData,
    });
  }
  requestNewShippingLabel(boxBarcode) {
    return this._sendRequest({
      method: `/box/${boxBarcode}/create-new-shipping-label`,
      headers: this._getAuthHeader(),
      data: {},
      run: this._server.postData,
    });
  }

  changeShippingMethod(boxBarcode) {
    return this._sendRequest({
      method: `/box/${boxBarcode}/change-shipping-method`,
      headers: this._getAuthHeader(),
      data: {},
      run: this._server.postData,
    });
  }

  printNewLabel(shippingId, shippingMethodId, cancelOldLabel) {
    let local = new ServerRequestWrapper(API_PATH);
    return this._sendRequest({
      method: `/api/review/printnewlabel`,
      data: {
        shippingId: shippingId,
        shippingMethod: shippingMethodId,
        cancelOldLabel: cancelOldLabel,
      },
      headers: {
        WorkstationID: getParamValue("ws"),
        AuthOperatorId: 392,
      },
      run: local.getData,
    });
  }

  relocateBox(boxBarcode, workstationId) {
    return this._sendRequest({
      method: `/box/${boxBarcode}/relocate`,
      headers: this._getAuthHeader(),
      data: workstationId,
      run: this._server.postData,
    });
  }
  cancelOrder(boxBarcode) {
    return this._sendRequest({
      method: `/box/${boxBarcode}/cancel`,
      headers: this._getAuthHeader(),
      run: this._server.postData,
    });
  }
  confirmExcessPick(boxBarcode, itemId) {
    return this._sendRequest({
      method: `/box/${boxBarcode}/restore-excess-pick`,
      headers: this._getAuthHeader(),
      data: itemId,
      run: this._server.postData,
    });
  }
  restock(boxBarcode, payload) {
    return this._sendRequest({
      method: `/box/${boxBarcode}/restock`,
      headers: this._getAuthHeader(),
      data: payload,
      run: this._server.postData,
    });
  }

  setWeightOnSku(boxBarcode, operatorId, skuId, weight) {
    return this._sendRequest({
      method: `/box/${boxBarcode}/set-weight-on-sku`,
      headers: this._getAuthHeader(),
      data: { operatorId, skuId, weight },
      run: this._server.getData,
    });
  }
}

export const conveyorBoxEndpoints = new ConveyorBoxEndpoints();
